export class DevelopmentObjective {
  studentIdpActivityId: number;
  studentIdpId?: number;
  studentId: number;
  name: string;
  status: number;
  dueDate?: Date;
  createDate: Date;
  actions: string;
  when: string;
  measurement: string;
  competencyId?: number;
  competencyName: string;
  courseId?: number;
  courseName: string;
  createdById: number;
  createdByType: number;
  creator: string;
  reviewPeriodId: number;

  comments: DevelopmentObjectiveComment[];

  canUpdate: boolean;

  // Display properties
  selected?: boolean;
}

export class EmployeeContractWrapper {
  studentId: number;
  firstName: string;
  lastName: string;
  functionName: string;
  departmentName: string;
  companyName: string;
  studentStatus: number;
  items: DevelopmentObjective[];
  studentIdpActivityId: number;
}

export class DevelopmentObjectiveComment {
  studentIDPNoteId: number;
  studentIDPId: number;
  studentIDPActivityId: number;
  createDate: Date;
  viewableByMgr: boolean;
  viewableByStudent: boolean;
  viewableByAdmin: boolean;
  commentKind: CommentKind;
  createdById: number;
  createdByType: number;
  commentType?: number;
  title: string;
  description: string;
  creatorName: string;
  studentId: number;
  dueDate: Date;
  status: number;
  when: string;
  measurement: string;

  // view properties
  visible?: number;
}

export enum CommentKind {
  PrivateComment = 0,
  PrivateCommentSharedWithinOwnRole = 1,
  PrivateCommentSharedBetweenManagersOrHr = 2,
  SharedComment = 3
}
